import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable react-hooks/exhaustive-deps */
import { BackdropLoader, BasicTooltip, Icon, SimpleModal, SummaryInfo } from '@livable/saas-react-components';
import { Accordion, AccordionDetails, AccordionSummary, Button, Paper, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TableModal from 'src/pages/AllocationTablesPage/AllocationUtility/TableModal';
import useAllocationUtilityStyles from 'src/pages/AllocationTablesPage/AllocationUtility/styles';
import { useStore } from 'src/stores';
const AllocationPreviewModal = _ref => {
  var _store$utilityProvide;
  let billingCycleId = _ref.billingCycleId,
    propertyId = _ref.propertyId,
    triggerType = _ref.triggerType,
    utility = _ref.utility;
  const classes = useAllocationUtilityStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const id = billingCycleId + propertyId + utility.utilityId;
  const queue = store.allocations.queue;
  const utilityTable = store.allocations.utilityById.get(billingCycleId + utility.utilityId);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    modalIsOpen = _useState6[0],
    setModalIsOpen = _useState6[1];
  useEffect(() => {
    if (!modalIsOpen) return;
    setIsLoading(id);
    store.allocations.addToQueue({
      billingCycleId,
      id,
      propertyId,
      utilityId: utility.utilityId
    });
  }, [modalIsOpen]);
  useEffect(() => {
    if (!queue.find(item => item.id === id)) setIsLoading(false);
  }, [queue]);
  const defaultTrigger = type => {
    return type === 'actionButton' ? /*#__PURE__*/React.createElement(Button, {
      size: "small",
      variant: "actionButton",
      'custom-attribute': '422-AllocationPreviewModal'
    }, "View allocation") : /*#__PURE__*/React.createElement(BasicTooltip, {
      title: t('resident_account.view_allocation_table'),
      placement: "top"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      'custom-attribute': '423-AllocationPreviewModal'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "table"
    })));
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: () => setModalIsOpen(false),
    handleOpen: () => setModalIsOpen(true),
    isOpen: modalIsOpen,
    noPadding: true,
    title: t('allocations.allocation_preview'),
    trigger: defaultTrigger(triggerType),
    variant: "large"
  }, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement(SummaryInfo, {
    allocationMethod: utilityTable === null || utilityTable === void 0 ? void 0 : utilityTable.allocationMethod,
    providerName: (_store$utilityProvide = store.utilityProviders.utilities.get(utility.utilityId)) === null || _store$utilityProvide === void 0 ? void 0 : _store$utilityProvide.providerName,
    showRecovery: true,
    summaryData: {
      'Allocated:': "$".concat((utilityTable === null || utilityTable === void 0 ? void 0 : utilityTable.allocated) || 0),
      'Bill total:': "$".concat((utilityTable === null || utilityTable === void 0 ? void 0 : utilityTable.billTotal) || 0),
      'Deductions:': "".concat((utilityTable === null || utilityTable === void 0 ? void 0 : utilityTable.deductions) || 0, "%"),
      'Recovery:': "".concat((utilityTable === null || utilityTable === void 0 ? void 0 : utilityTable.recovery) || 0, "%")
    },
    utilityType: utility.utilityTypeName
  }), /*#__PURE__*/React.createElement(Accordion, {
    className: classes.detailsTable,
    expanded: isExpanded
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "allocation-details",
    expandIcon: /*#__PURE__*/React.createElement(Icon, {
      fontSize: "large",
      type: "arrow-line-right"
    }),
    id: "allocation-details",
    onClick: () => setIsExpanded(prevValue => !prevValue)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('allocations.view_ratio_billed_units_table')), /*#__PURE__*/React.createElement("div", {
    className: classes.totalSummary
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('allocations.ratio_billed_total'), "\xA0"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "$", (utilityTable === null || utilityTable === void 0 ? void 0 : utilityTable.ratioBilledTotal) || 0)))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(TableModal, {
    allocations: (utilityTable === null || utilityTable === void 0 ? void 0 : utilityTable.allocations) || []
  })))));
};
export default AllocationPreviewModal;